import PropTypes from 'prop-types';

import { trans, useSoyuzClientConfig } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import {
  getStaticMapUrl,
  getStaticMapUrlMapbox,
  getStaticMapUrlWoosmap
} from '@spotahome/marketplace-common/src/utils/static-map';

import './MapPlaceholder.scss';

const MapPlaceholder = ({
  city,
  cityCenterCoords,
  onButtonClick,
  mapProviderVariant = 'google'
}) => {
  const { defaultZoom, mapboxAccessToken, googleMapsApiKey, woosmapApiKey } =
    useSoyuzClientConfig();
  const cityZoom = defaultZoom[city];

  const buildSrc = () => {
    const coords = {
      lat: cityCenterCoords.lat,
      lng: cityCenterCoords.lng,
      zoom: cityZoom
    };

    if (mapProviderVariant === 'mapbox') {
      return getStaticMapUrlMapbox({
        ...coords,
        accessToken: mapboxAccessToken
      });
    }

    if (mapProviderVariant === 'woosmap') {
      return getStaticMapUrlWoosmap({ ...coords, apiKey: woosmapApiKey });
    }

    return getStaticMapUrl({ ...coords, apiKey: googleMapsApiKey });
  };

  const src = buildSrc();

  return (
    <div className="map-placeholder">
      <img
        className="map-placeholder__image map-placeholder__image--blur"
        src={src}
        alt="map placeholder"
      />

      <Button
        onClick={onButtonClick}
        color="secondary"
        data-test="search-map-activation"
      >
        {trans('map.lazy.cta.text')}
      </Button>
    </div>
  );
};

MapPlaceholder.propTypes = {
  city: PropTypes.string.isRequired,
  cityCenterCoords: PropTypes.shape({
    lat: PropTypes.string,
    lng: PropTypes.string
  }).isRequired,
  onButtonClick: PropTypes.func.isRequired,
  mapProviderVariant: PropTypes.string
};

export default MapPlaceholder;
